import { fetchRemoteConfig } from '../common-classes/firebase.service';
import { RemoteConfigKeys } from '../enum/remote-keys';
import { setIsOpenAuthModal } from '../store/slices/auth.slice';
import { setIsOpen } from '../store/slices/popup.slice';
import { dispatch } from '../store/store';

export class AuthPopupService {
    async getPopup() {
        const firebaseAuth = (await fetchRemoteConfig(
            RemoteConfigKeys.WEB_AUTH_SWITCH,
            'boolean'
        )) as string;
        const appCtaData = (await fetchRemoteConfig(
            RemoteConfigKeys.QR_LINK,
            'object'
        )) as string;
        const envFilters = process.env.NEXT_PUBLIC_SELF_URL;
        if (envFilters === 'https://www.hotdesk.com/') {
            if (firebaseAuth) {
                dispatch(setIsOpenAuthModal(true));
            } else {
                if (window.innerWidth > 992) {
                    dispatch(setIsOpen(true));
                } else {
                    window.location.href = appCtaData;
                }
            }
        } else {
            dispatch(setIsOpenAuthModal(true));
        }
    }
}
